<template>
  <div class="five-function">
    <div class="function">
      <div class="function-top">
        <h3>5G彩信主要功能类型</h3>
        <span></span>
      </div>
      <span class="function-text">
        链起您与用户的沟通桥梁，做就做说一不二的精准营销
      </span>
      <article class="function-content">
        <div class="article-top clearfix">
          <a
            v-for="top in topList"
            :key="top.id"
            @click="active(top.id)"
            :class="{ active: number == top.id }"
            >{{ top.text }}</a
          >
        </div>
        <div v-if="number == 3" class="article-bottom1">
          <div class="left">
            <div class="left-top">
              <img :src="topList[3].img" />
              <span>{{ topList[3].top }}</span>
            </div>
            <div class="left-bottom">
              <div class="left-title">
                <a> {{ topList[3].title1 }}</a>
                <img :src="topList[3].simg" />
              </div>
              <div
                class="left-item"
                v-for="(bottom1, index) in topList[3].bottom1"
                :key="index"
              >
                <img :src="bottom1.img" />
                <div class="img-right">
                  <span class="span-1">{{ bottom1.text1 }}</span>
                  <span class="span-2">{{ bottom1.text2 }}</span>
                </div>
              </div>
              <div class="left-title left-title1">
                <a> {{ topList[3].title2 }}</a>
                <img :src="topList[3].simg" />
              </div>
              <div class="left-item-top">
                <div class="div-left">
                  <div class="img-top clearfix">
                    <div class="img-span">
                      <span class="span-1">{{
                        topList[3].bottom2[0].text1
                      }}</span>
                      <span class="span-2">{{
                        topList[3].bottom2[0].text2
                      }}</span>
                    </div>
                    <div class="z-img">
                      <img :src="topList[3].zimg" />
                      <img :src="topList[3].bottom2[0].img" />
                    </div>
                  </div>
                  <div class="fgx-img clearfix">
                    <img :src="topList[3].fgximg" />
                  </div>
                  <div class="img-bottom clearfix">
                    <div class="img-span">
                      <span class="span-1">{{
                        topList[3].bottom2[1].text1
                      }}</span>
                      <span class="span-2">{{
                        topList[3].bottom2[1].text2
                      }}</span>
                    </div>
                    <div class="z-img">
                      <img :src="topList[3].zimg" />
                      <img :src="topList[3].bottom2[1].img" />
                    </div>
                  </div>
                </div>
                <div class="div-right">
                  <div class="y-img">
                    <img :src="topList[3].bottom2[2].img" />
                    <img :src="topList[3].yimg" />
                  </div>
                  <div class="img-span">
                    <span class="span-1">{{
                      topList[3].bottom2[2].text1
                    }}</span>
                    <span class="span-2">{{
                      topList[3].bottom2[2].text2
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <img :src="topList[3].bgimg" class="left-yuan clearfix" />
          </div>
          <div class="right">
            <img :src="topList[3].img1" />
            <a>立即体验</a>
            <img class="gif" src="../../static/images/fiveG/function/qsc.gif" />
          </div>
        </div>
        <div
          v-else
          v-for="(top, index) in topList.slice(number, number + 1)"
          :key="index"
          class="article-bottom"
        >
          <div class="left">
            <div>
              <a @click="active2(0)" :class="{ active: number2 == 0 }">
                {{ top.child[0].title }}</a
              >
            </div>
            <div>
              <a @click="active2(1)" :class="{ active: number2 == 1 }">
                {{ top.child[1].title }}</a
              >
            </div>
          </div>
          <div
            class="center"
            :class="[
              { more1: top.child[number2].biao == 0 },
              {
                more2:
                  top.child[number2].biao == 2 || top.child[number2].biao == 4
              }
            ]"
          >
            <div class="center-top">
              <img :src="top.child[number2].img" />
              <span>{{ top.child[number2].top }}</span>
            </div>
            <div class="center-bottom">
              <div
                v-for="(bottom, index) in top.child[number2].bottom"
                :key="index"
              >
                <img :src="bottom.img" />
                <span class="span-1">{{ bottom.text1 }}</span>
                <span class="span-2">{{ bottom.text2 }}</span>
              </div>
            </div>
          </div>
          <div class="right">
            <img src="../../static/images/fiveG/function/tw.png" />
            <a>立即体验</a>
            <img class="gif" :src="top.gif" />
          </div>
        </div>
      </article>
    </div>
  </div>
</template>
<script>
export default {
  name: "fiveFunction",
  data() {
    return {
      number: 0,
      number2: 0,
      topList: [
        {
          id: 0,
          text: "文字短信",
          child: [
            {
              id: 0,
              biao: 0,
              title: "会员营销短信",
              img: require("../../static/images/fiveG/function/wz-hy.png"),
              top: "支持运营类文字短信服务，三网合一的高质量专用通道，金融级别安全保护；适用于会员服务、客户关怀、新品上线等使用场景",
              bottom: [
                {
                  id: 0,
                  img: require("../../static/images/fiveG/function/zdy.png"),
                  text1: "自定义",
                  text2: "个性化签名",
                },
                {
                  id: 1,
                  img: require("../../static/images/fiveG/function/td.png"),
                  text1: "通道支持",
                  text2: "移动/联通/电信高速通道",
                },
                {
                  id: 2,
                  img: require("../../static/images/fiveG/function/wz.png"),
                  text1: "文字字数",
                  text2: "字数不限，可容纳长篇小说",
                },
                {
                  id: 3,
                  img: require("../../static/images/fiveG/function/ddsj.png"),
                  text1: "到达时间",
                  text2: "5-10秒到达",
                },
                {
                  id: 4,
                  img: require("../../static/images/fiveG/function/fsfs.png"),
                  text1: "发送方式",
                  text2: "客户自发",
                },
                {
                  id: 5,
                  img: require("../../static/images/fiveG/function/cgl.png"),
                  text1: "发送成功率",
                  text2: "达99%",
                },
                {
                  id: 6,
                  img: require("../../static/images/fiveG/function/lj.png"),
                  text1: "是否支持链接",
                  text2: "支持",
                },
                {
                  id: 7,
                  img: require("../../static/images/fiveG/function/hf.png"),
                  text1: "是否支持回复",
                  text2: "支持",
                },
              ]
            },
            {
              id: 1,
              biao: 1,
              title: "通知短信",
              img: require("../../static/images/fiveG/function/wz-tz.png"),
              top: "支持各类业务场景的短信通知服务，国内短信三网合一的高质量专用通道，秒即可达，支持变量，内容灵活，适用于服务通知、系统通知等应用场景",
              bottom: [
                {
                  id: 0,
                  img: require("../../static/images/fiveG/function/zdy.png"),
                  text1: "自定义",
                  text2: "个性化签名",
                },
                {
                  id: 1,
                  img: require("../../static/images/fiveG/function/td.png"),
                  text1: "通道支持",
                  text2: "移动/联通/电信高速通道",
                },
                {
                  id: 2,
                  img: require("../../static/images/fiveG/function/wz.png"),
                  text1: "文字字数",
                  text2: "字数不限，可容纳长篇小说",
                },
                {
                  id: 3,
                  img: require("../../static/images/fiveG/function/ddsj.png"),
                  text1: "到达时间",
                  text2: "5-10秒到达",
                },
                {
                  id: 4,
                  img: require("../../static/images/fiveG/function/fsfs.png"),
                  text1: "发送方式",
                  text2: "客户自发",
                },
                {
                  id: 5,
                  img: require("../../static/images/fiveG/function/cgl.png"),
                  text1: "发送成功率",
                  text2: "达99%",
                },
                {
                  id: 6,
                  img: require("../../static/images/fiveG/function/lj.png"),
                  text1: "是否支持链接",
                  text2: "支持",
                },
                {
                  id: 7,
                  img: require("../../static/images/fiveG/function/hf.png"),
                  text1: "是否支持回复",
                  text2: "支持",
                },
                {
                  id: 8,
                  img: require("../../static/images/fiveG/function/ksh.png"),
                  text1: "可视化编辑",
                  text2: "可视化预览编辑模式，操作便捷",
                },
              ]
            }
          ]
        },
        {
          id: 1,
          text: "视频短信",
          gif: require("../../static/images/fiveG/function/spdx.gif"),
          child: [
            {
              id: 0,
              biao: 2,
              title: "产品优势",
              img: require("../../static/images/fiveG/function/sp.png"),
              top: "视频短信，又称为视频彩信、5G彩信，通过提供直达、便携、大容量、内容丰富的视频化多媒体信息服务，为客户带来全方位的内容服务和营销价值。适用于商业，党政宣传、媒体广告等业务场景",
              bottom: [
                {
                  id: 0,
                  img: require("../../static/images/fiveG/function/sjcj.png"),
                  text1: "视觉冲击感受强烈",
                  text2: "实现2M大容量富媒体短信推送，相当于15秒高清视频",
                },
                {
                  id: 1,
                  img: require("../../static/images/fiveG/function/zdmb.png"),
                  text1: "直达目标用户",
                  text2: "继承了短信高效直达的特点,为客户节省高额的粉丝运营成本",
                },
                {
                  id: 2,
                  img: require("../../static/images/fiveG/function/mll.png"),
                  text1: "免流量费用，成功率高",
                  text2: "用户接受视频流量免费，支持百万数量级的并发下载，下载响应迅速，成功率达90%以上",
                },
              ]
            },
            {
              id: 1,
              biao: 3,
              title: "功能描述",
              img: require("../../static/images/fiveG/function/sp.png"),
              top: "视频短信，又称为视频彩信、5G彩信，通过提供直达、便携、大容量、内容丰富的视频化多媒体信息服务，为客户带来全方位的内容服务和营销价值。适用于商业，党政宣传、媒体广告等业务场景",
              bottom: [
                {
                  id: 0,
                  img: require("../../static/images/fiveG/function/zdy.png"),
                  text1: "自定义",
                  text2: "个性化签名",
                },
                {
                  id: 1,
                  img: require("../../static/images/fiveG/function/td.png"),
                  text1: "通道支持",
                  text2: "移动/联通/电信高速通道",
                },
                {
                  id: 2,
                  img: require("../../static/images/fiveG/function/nrdx.png"),
                  text1: "内容大小",
                  text2: "实现2M大容量富媒体短信推送",
                },
                {
                  id: 3,
                  img: require("../../static/images/fiveG/function/spgs.png"),
                  text1: "视频格式",
                  text2: "支持mp4、3gpp格式",
                },
                {
                  id: 4,
                  img: require("../../static/images/fiveG/function/ddsj.png"),
                  text1: "到达时间",
                  text2: "5-10秒到达",
                },
                {
                  id: 5,
                  img: require("../../static/images/fiveG/function/fsfs.png"),
                  text1: "发送方式",
                  text2: "客户自发",
                },
                {
                  id: 6,
                  img: require("../../static/images/fiveG/function/cgl.png"),
                  text1: "发送成功率",
                  text2: "达99%",
                },
                {
                  id: 7,
                  img: require("../../static/images/fiveG/function/lj.png"),
                  text1: "是否支持链接",
                  text2: "支持",
                },
                {
                  id: 8,
                  img: require("../../static/images/fiveG/function/hf.png"),
                  text1: "是否支持回复",
                  text2: "支持",
                },
                {
                  id: 9,
                  img: require("../../static/images/fiveG/function/ksh.png"),
                  text1: "可视化编辑",
                  text2: "可视化预览编辑模式，操作便捷",
                },
              ]
            }
          ]
        },
        {
          id: 2,
          text: "图文短信",
          gif: require("../../static/images/fiveG/function/twdx.gif"),
          child: [
            {
              id: 0,
              biao: 4,
              title: "产品优势",
              img: require("../../static/images/fiveG/function/twdx.png"),
              top: "支持多媒体功能，能够传递丰富全面的内容和信息，这些信息包括文字、图像、声音、数据等多媒体格式的信息",
              bottom: [
                {
                  id: 0,
                  img: require("../../static/images/fiveG/function/sjcj.png"),
                  text1: "视觉冲击感受强烈",
                  text2: "实现2M大容量富媒体短信推送",
                },
                {
                  id: 1,
                  img: require("../../static/images/fiveG/function/zdmb.png"),
                  text1: "直达目标用户",
                  text2: "继承了短信高效直达的特点,为客户节省高额的粉丝运营成本",
                },
                {
                  id: 2,
                  img: require("../../static/images/fiveG/function/mll.png"),
                  text1: "免流量费用，成功率高",
                  text2: "用户接受视频流量免费，支持百万数量级的并发下载，下载响应迅速，成功率达90%以上",
                },
              ]
            },
            {
              id: 1,
              biao: 5,
              title: "功能描述",
              img: require("../../static/images/fiveG/function/twdx.png"),
              top: "支持多媒体功能，能够传递丰富全面的内容和信息，这些信息包括文字、图像、声音、数据等多媒体格式的信息",
              bottom: [
                {
                  id: 0,
                  img: require("../../static/images/fiveG/function/zdy.png"),
                  text1: "自定义",
                  text2: "个性化签名",
                },
                {
                  id: 1,
                  img: require("../../static/images/fiveG/function/td.png"),
                  text1: "通道支持",
                  text2: "移动/联通/电信高速通道",
                },
                {
                  id: 2,
                  img: require("../../static/images/fiveG/function/nrdx.png"),
                  text1: "内容大小",
                  text2: "实现2M大容量富媒体短信推送，相当于5-10张高清图片",
                },
                {
                  id: 3,
                  img: require("../../static/images/fiveG/function/spgs.png"),
                  text1: "视频格式",
                  text2: "支持gif、png、jpeg格式",
                },
                {
                  id: 4,
                  img: require("../../static/images/fiveG/function/ddsj.png"),
                  text1: "到达时间",
                  text2: "5-10秒到达",
                },
                {
                  id: 5,
                  img: require("../../static/images/fiveG/function/fsfs.png"),
                  text1: "发送方式",
                  text2: "客户自发",
                },
                {
                  id: 6,
                  img: require("../../static/images/fiveG/function/cgl.png"),
                  text1: "发送成功率",
                  text2: "达99%",
                },
                {
                  id: 7,
                  img: require("../../static/images/fiveG/function/lj.png"),
                  text1: "是否支持链接",
                  text2: "支持",
                },
                {
                  id: 8,
                  img: require("../../static/images/fiveG/function/hf.png"),
                  text1: "是否支持回复",
                  text2: "支持",
                },
                {
                  id: 9,
                  img: require("../../static/images/fiveG/function/ksh.png"),
                  text1: "可视化编辑",
                  text2: "可视化预览编辑模式，操作便捷",
                },
              ]
            }
          ]
        },
        {
          id: 3,
          text: "轻商城",
          biao: 6,
          title1: "产品优势",
          title2: "系统功能",
          img: require("../../static/images/fiveG/function/qsc.png"),
          img1: require("../../static/images/fiveG/function/qsc(1).png"),
          bgimg: require("../../static/images/fiveG/function/bg.png"),
          simg: require("../../static/images/fiveG/function/s.png"),
          zimg: require("../../static/images/fiveG/function/z.png"),
          yimg: require("../../static/images/fiveG/function/y.png"),
          fgximg: require("../../static/images/fiveG/function/fgx.png"),
          top: "轻商城已成为5G彩信生态内的红利聚集地，流量红利助你轻松获客、裂变、复购",
          bottom1: [
            {
              id: 0,
              img: require("../../static/images/fiveG/function/kskt.png"),
              text1: "快速开通，快速转化",
              text2: "开通5G彩信，即可拥有品牌或商户自营商城",
            },
            {
              id: 1,
              img: require("../../static/images/fiveG/function/yth.png"),
              text1: "5G一体化营销加速转化",
              text2: "5G彩信与轻商城互通，流量导入轻松转化",
            },
            {
              id: 2,
              img: require("../../static/images/fiveG/function/gy.png"),
              text1: "更优体验提升付费转化",
              text2: "产品体验比小程序更流畅，极大程度提高转化率",
            },
          ],
          bottom2: [
            {
              id: 0,
              img: require("../../static/images/fiveG/function/xfz.png"),
              text1: "消费者",
              text2: "优惠券、商品秒杀、限时折扣、商品预售、订单详情",
            },
            {
              id: 1,
              img: require("../../static/images/fiveG/function/pt.png"),
              text1: "平台管理员",
              text2: "用户管理、物流管理、订单管理、商城装修、商品投诉、财务管理、营销功能",
            },
            {
              id: 2,
              img: require("../../static/images/fiveG/function/sh.png"),
              text1: "商户管理员",
              text2: "商品管理、售后管理、投诉管理、营销活动管理、用户订单、订单管理、统计管理、物流管理",
            },
          ]
        },
      ],
    }
  },
  methods: {
    active: function (index) {
      this.number = index;
      this.number2 = 0;
    },
    active2: function (index) {
      this.number2 = index;
    }
  }
}
</script>
<style lang="stylus" scoped>
.clearfix:before, .clearfix:after {
  content: '';
  display: table;
  clear: both;
}

.five-function {
  width: 100%;
  margin: 0 auto;
  margin-top: 40px;
  padding-top: 80px;
  padding-bottom: 38px;
  text-align: center;
  background-color: #F5F5F5;
}

.function {
  width: 1400px;
  margin: 0 auto;
}

.function-top h3 {
  font-size: 30px;
  font-weight: 600;
  letter-spacing: 2px;
}

.function-top span {
  display: block;
  margin: 20px auto 0;
  content: '';
  width: 42px;
  height: 4px;
  border-bottom: 2px solid #FFC000;
}

.function-text {
  display: inline-block;
  font-size: 18px;
  margin-top: 23px;
}

.function-content {
  width: 1400px;
  margin: 40px auto;

  .article-top {
    width: 100%;
    display: inline-block;
    font-size: 20px;
    border-bottom: 1px solid #DBDBDB;

    a {
      display: inline-block;
      height: 50px;
      text-decoration: none;
      color: black;
      cursor: pointer;
      line-height: 50px;
      margin: auto 70px;
      position: relative;
      top: 2.5px;
      z-index: 1;
    }

    .active {
      border-bottom: 5px solid #FFC000;
      font-weight: bold;
    }
  }

  .article-bottom {
    display: inline-block;
    width: 1400px;
    height: 525px;
    font-size: 18px;
    background-color: white;
    margin-top: 26px;

    a {
      text-decoration: none;
      color: black;
    }

    .left {
      width: 103px;
      height: 500px;
      float: left;
      box-sizing: border-box;
      font-size: 18px;

      div {
        width: 100%;
        height: 250px;
        line-height: 18px;
        margin: 0 auto;
        box-sizing: border-box;

        a {
          width: 40px;
          display: inline-block;
          float: left;
          margin-top: 75px;
          padding-left: 20px;
          cursor: pointer;
          box-sizing: border-box;
          border-left: 6px solid white;
        }

        .active {
          border-left: 6px solid #FFC000;
          font-weight: bold;
        }
      }
    }

    .center {
      display: inline-block;
      width: 1000px;
      margin-top: 35px;
      float: left;

      .center-top {
        display: inline-block;
        width: 100%;
        font-weight: bold;

        img {
          float: left;
        }

        span {
          display: inline-block;
          width: 895px;
          padding-top: 10px;
          line-height: 25px;
          margin-left: 12px;
          text-align: left;
        }
      }

      .center-bottom {
        display: block;
        width: 1000px;
        height: 350px;
        text-align: left;
        padding-top: 17px;

        div {
          width: 184px;
          height: 138px;
          border: 1px solid #F3F3F3;
          float: left;
          margin-left: 20px;
          margin-top: 32px;
          padding-top: 25px;
          padding-left: 15px;
          padding-right: 15px;
          box-sizing: border-box;
          background: #FFFFFF;

          img {
            vertical-align: bottom;
          }

          .span-1 {
            font-weight: bold;
          }

          .span-2 {
            height: 60px;
            font-size: 16px;
            margin-top: 10px;
            line-height: 24px;
            display: flex;
            align-items: center;
          }
        }

        div:first-child, div:nth-child(6) {
          margin-left: 0;
        }
      }

      .center-bottom div:hover {
        box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
        transform: translateY(-15px);
      }
    }

    .more1 {
      width: 910px;

      .center-top {
        span {
          width: 830px;
        }
      }

      .center-bottom {
        width: 950px;

        div {
          width: 207px;
          margin-left: 30px;
        }

        div:nth-child(5) {
          margin-left: 0px;
        }

        div:nth-child(6) {
          margin-left: 32px;
        }
      }
    }

    .more2 {
      width: 938px;

      .center-top {
        span {
          width: 858px;
        }
      }

      .center-bottom {
        div {
          width: 300px;
          height: 308px;
          padding-top: 33px;
          text-align: center;
          margin-left: 30px;

          .span-1 {
            margin-top: 27px;
            display: block;
          }

          .span-2 {
            display: block;
            margin: 30px auto;
          }
        }
      }
    }

    .right {
      display: inline-block;
      float: right;
      width: 201px;
      margin-right: 50px;

      img {
        display: inline-block;
        margin-top: 20px;
      }

      a {
        display: inline-block;
        width: 170px;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #FFC000;
        font-size: 16px;
        background: #FFC000;
        line-height: 40px;
        margin-top: 20px;
      }

      .gif {
        position: relative;
        width: 189px;
        top: -485px;
        border-radius: 1px;
        overflow: hidden;
      }
    }
  }

  .article-bottom1 {
    display: inline-block;
    width: 1400px;
    height: 525px;
    font-size: 18px;
    background-color: white;
    margin-top: 26px;

    a {
      text-decoration: none;
      color: black;
    }

    .left {
      display: inline-block;
      width: 1112px;
      float: left;
      padding-left: 31px;
      padding-top: 25px;
      text-align: left;

      .span-1 {
        display: block;
        font-size: 16px;
        font-weight: bold;
      }

      .span-2 {
        line-height: 24px;
        font-size: 14px;
        margin-top: 15px;
        display: flex;
        align-items: center;
      }

      .left-top {
        span {
          display: inline-block;
          font-weight: bold;
          margin-left: 10px;
        }
      }

      .left-bottom {
        display: inline-block;
        width: 100%;
        height: 400px;
        float: left;
        box-sizing: border-box;
        position: relative;
        z-index: 2;

        .left-title {
          width: 50px;
          line-height: 18px;
          margin: 5px auto;
          box-sizing: border-box;
          float: left;

          a {
            width: 25px;
            display: inline-block;
            float: left;
            margin-top: 60px;
            padding-left: 3px;
            box-sizing: border-box;
            font-weight: bold;
          }

          img {
            display: inline-block;
            margin-top: 96px;
            margin-left: 15px;
          }
        }

        .left-title1 {
          margin-top: 13px;
        }

        .left-item {
          width: 280px;
          height: 130px;
          border: 1px solid #F3F3F3;
          float: left;
          margin-left: 38px;
          margin-right: 10px;
          margin-top: 39px;
          padding: 20px 15px;
          box-sizing: border-box;

          .img-right {
            display: inline-block;
            width: 70%;
            margin-left: 10px;
            letter-spacing: 0px;
          }
        }

        .left-item:hover {
          box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
          transform: scale(1.1, 1.1);
        }

        .left-item-top {
          display: inline-block;
          width: 1000px;
          margin-top: 58px;
          margin-left: 30px;

          .div-left {
            display: inline-block;
            width: 46%;
            float: left;
            margin-left: 33px;

            .img-span {
              text-align: right;
              float: left;
              margin-left: 13px;

              .span-2 {
                width: 335px;
                margin-top: 10px;
              }
            }

            .z-img {
              float: right;
              margin-right: 4px;
            }

            .fgx-img {
              margin-top: 10px;
              margin-bottom: 20px;
            }

            .img-top {
              width: 96%;
            }

            .img-bottom {
              width: 96%;
              margin-left: 10px;
            }
          }

          .div-right {
            display: inline-block;
            width: 50%;
            float: right;
            margin-top: 48px;

            .img-span {
              width: 75%;
              float: left;
              margin-left: 15px;

              .span-2 {
                margin-top: 10px;
              }
            }

            .y-img {
              float: left;
              margin-left: 5px;
            }
          }
        }
      }

      .left-yuan {
        position: relative;
        width: 124px;
        heigth: 121px;
        box-sizing: border-box;
        top: -150px;
        left: 500px;
        z-index: 1;
      }
    }

    .right {
      display: inline-block;
      float: right;
      width: 201px;
      margin-right: 50px;

      img {
        display: inline-block;
        margin-top: 20px;
      }

      a {
        display: inline-block;
        width: 170px;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #FFC000;
        font-size: 16px;
        background: #FFC000;
        line-height: 40px;
        margin-top: 20px;
      }

      .gif {
        position: relative;
        width: 189px;
        top: -485px;
        border-radius: 1px;
        overflow: hidden;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/FiveFunction.vue